module.exports = __webpack_public_path__ + "img/maja-ser-det-fede-1.01d42588.png";